import React from "react";
import TestimonialItem from "../TestimonialItem";
import styles from "./TestimonialSection.module.css"
import PropTypes from "prop-types";


export const TestimonialSection =({testimonials})=> {
    return (
        <div className={styles.container}>            
            <h4 className={styles.style}>What Pilots Are Saying!</h4>               
            <div className={styles.eachTestimonial}>
                {testimonials.map((testimonial, index) => (                    
                    <TestimonialItem
                        key={index}
                        quote={testimonial.quote}
                        name={testimonial.name}
                        company={testimonial.company}
                    />
                ))}
            </div>
        </div>
    )
}
TestimonialSection.propTypes = {
    testimonials: PropTypes.arrayOf(
        PropTypes.shape({
            quote: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            company: PropTypes.string.isRequired
        })
    ).isRequired
};